<template>
  <div class="qr-wrapper" ref="qr_wrapper">
    <img :src="url" alt="QR Code" style="padding: 8px" />
    <a :href="url" @click.prevent="downloadPDF(url)">Download as PDF</a>
  </div>
</template>

<script>
// import { jsPDF } from "jspdf";
import axios from "axios";
import { saveAs } from "file-saver";
export default {
  name: "QRCode",
  props: ["url"],
  methods: {
    downloadPDF(url) {
      let pdfUrl = url;
      pdfUrl = pdfUrl.replace("/images/", "/pdf/");
      pdfUrl = pdfUrl.replace(".png", ".pdf");
      axios.get(pdfUrl, { responseType: "blob" }).then((response) => {
        saveAs(response.data, "QR Code.pdf");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.qr-wrapper {
  width: 208px;
  height: 231px;
  background-color: #f3f3f3;
  border-radius: 8px;
  border: 2.5px solid #f3f3f3;
  margin: 0 auto 20px;
  padding-top: 20px;
  padding-inline-end: 25px;
  padding-bottom: 0;
  padding-inline-start: 25px;
  // position: relative;
  img {
    border-radius: 11px;
    border: 6.5px solid #000000;
    margin-bottom: 8px;
    width: 143px;
    height: 143px;
  }
  a {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    margin-bottom: 26px;
    color: #000000;
    white-space: nowrap;
    // position: absolute;
    // top: 130px;
    // inset-inline-start: 30px;
    white-space: nowrap;
  }
}
@media (max-width: 992px) {
  .qr-wrapper {
    width: 162px;
    height: 162px;
    background-color: #f3f3f3;
    border-radius: 8px;
    border: 2.5px solid #f3f3f3;
    margin: 49px auto 59px Auto;
    padding-top: 32px;
    padding-inline-end: 25px;
    padding-bottom: 0;
    padding-inline-start: 26px;

    img {
      border-radius: 11px;
      border: 6.5px solid #000000;
      margin-bottom: 6.5px;
      width: 111px;
      height: 111px;
    }
    a {
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      text-align: center;
      margin-bottom: 8px;
      color: #000000;
      white-space: nowrap;
    }
  }
}
@media print {
  .qr-wrapper a {
    display: none;
  }
}
</style>